import { Type } from 'class-transformer';

import type { UserRoles } from '../store/useUser';

export enum AuthStatusEnum {
  LOADING = 'LOADING',
  LOGGED_IN = 'LOGGED_IN',
  LOGGED_OUT = 'LOGGED_OUT'
}

export interface IUser {
  id: number;
  email: string;
  fullname: string;
  username: string;
  name: string;
  surname: string;
  phone: string;
  emailVerified?: number;
  phoneVerified?: number;
}

export class IToken {
  token: string;
  @Type(() => Date)
  expires: Date;
}

export class IUserLogin {
  @Type(() => IToken)
  accessToken: IToken;
  @Type(() => IToken)
  refreshToken: IToken;
  user: IUser;
}

export interface ILogin {
  username: string;
  password: string;
  cloudflareToken: string;
}

export interface IRefreshToken {
  token: string;
}

export class AgreementStatus {
  isAgreementModal?: boolean;
  agreementEndDate?: Date;
  daysUntilAgreementExpiry?: number;
}

export class IMeResponse extends AgreementStatus {
  result: IUser;
  abilities: {
    abilities: string;
    mongoAbilities: string;
    groups: UserRoles[];
  };
}

export class IPostAuthSmsStart {
  phoneNumber: string;
}
export class IAuthSmsStartResponse {
  input: string;
}

export class IPostAuthSmsVerify {
  input: string;
  otp: string;
}

export class IAuthSmsVerifyResponse {
  message: string;
}

export class IPostAuthEmailStart {
  email: string;
}
export class IAuthEmailStartResponse {
  input: string;
}

export class IPostAuthEmailVerify {
  input: string;
  otp: string;
}

export class IAuthEmailVerifyResponse {
  message: string;
}

export class IPostAuthForgot {
  email: string;
  cloudflareToken: string;
}

export class IPostAuthForgotEnd {
  token: string;
  newPassword: string;
}
